import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { certifications } from '../../data/constants';
import CertificationCard from '../Cards/CertificationCard';
import { fadeUpVariants, staggerContainer } from '../../App';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 60px 0px 80px 0px;
    @media (max-width: 960px) {
        padding: 40px 0px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 40px 20px 0px 20px;
    gap: 16px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

const Title = styled.div`
    font-size: 48px;
    text-align: center;
    font-weight: 700;
    margin-top: 20px;
    background: linear-gradient(135deg, ${({ theme }) => theme.text_primary} 0%, ${({ theme }) => theme.primary} 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 36px;
    }
`;

const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    line-height: 1.6;
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;

const CertificationsGrid = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 32px;
    margin-top: 32px;
`;

const Certifications = () => {
    return (
        <Container id="certifications">
            <Wrapper
                as={motion.div}
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
            >
                <motion.div variants={fadeUpVariants}>
                    <Title>Certifications</Title>
                </motion.div>
                <motion.div variants={fadeUpVariants}>
                    <Desc>
                        Here are some of my certifications that showcase my continuous learning and professional development.
                    </Desc>
                </motion.div>
                <CertificationsGrid>
                    {certifications.map((certification, index) => (
                        <motion.div
                            key={certification.id}
                            variants={fadeUpVariants}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            transition={{ delay: index * 0.1 }}
                        >
                            <CertificationCard certification={certification} />
                        </motion.div>
                    ))}
                </CertificationsGrid>
            </Wrapper>
        </Container>
    );
};

export default Certifications;
